import styled from 'styled-components';

export const Container = styled.div`
	width: 500px;

	@media (max-width: 480px) {
		width: 350px;
	}
`;

export const Content = styled.div`
	padding: 16px 16px 0;
`;

export const ButtonWrapper = styled.div`
	position: sticky;
	bottom: 0;
	width: 100%;
	background-color: ${({ theme }) => theme.colors.neutral.white};
	border-top: 1px solid ${({ theme }) => theme.colors.neutral.grey};
	display: flex;
	gap: 20px;
	padding: 16px;
`;
